import { render } from "./chart-apex.vue?vue&type=template&id=924c7066"
import script from "./chart-apex.vue?vue&type=script&lang=js"
export * from "./chart-apex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__